export default __webpack_public_path__ + "static/media/awaiting-port.fd42721b.png";